export default "__VITE_ASSET__ClBXVLUC__";